<template>
  <div id="collectionDetailModal" class="content">
    <modal :show.sync="shouldShow" @hidden="onClickCancel" v-on:close="onClickCancel" footerClasses="justify-content-center" type="notice">
      <h4 slot="header" class="modal-title">
        <b>추천노출</b>
      </h4>
      <div class="row">
        <div class="col-sm-3">
          <h4 class="card-title text-left">시작시간</h4>
          <div class="row">
            <div class="col-md-12 text-left">
              <base-input placeholder="시작시간">
                <el-date-picker type="datetime" placeholder="시작시간" v-model="startTime"></el-date-picker>
              </base-input>
            </div>
          </div>
        </div>
        <div class="col-sm-3">
          <h4 class="card-title text-left">종료시간</h4>
          <div class="row">
            <div class="col-md-12 text-left">
              <base-input placeholder="종료시간">
                <el-date-picker type="datetime" placeholder="종료시간" v-model="endTime"></el-date-picker>
              </base-input>
            </div>
          </div>
        </div>
      </div>

      <div slot="footer" class="justify-content-center">
        <base-button class="footer-buttons col-6" type="success" round @click.native="onClickConfirm">확인</base-button>
        <base-button class="footer-buttons col-6" type="danger" round @click.native="onClickCancel">취소</base-button>
      </div>
    </modal>
  </div>
</template>
<script>
import { BaseInput, Modal } from "@/components/index";
import BaseButton from "@/components/BaseButton";

export default {
  name: "FanLogDetailModal",
  components: {
    BaseButton,
    BaseInput,
    Modal,
  },
  created() {
    this.isProcessing = false;
  },
  data() {
    return {
      startTime: null,
      endTime: null,
    };
  },
  props: {
    unitId: Number,
    fanLogId: Number,
    shouldShow: {
      type: Boolean,
      required: true,
    },
    onConfirm: {
      type: Function,
      required: true,
    },
    onCancel: {
      type: Function,
      required: true,
    },
  },
  methods: {
    changeType() {},
    onClickConfirm: async function () {
      if (!this.startTime || !this.endTime) {
        Toast.error("시간을 입력해주세요");
        return;
      }

      await this.onConfirm();

      const param = {};

      param.unitId = this.unitId;
      param.startTime = this.startTime;
      param.endTime = this.endTime;
      return this.$axios
        .post(`/fanLogs/${this.fanLogId}/hot`, param)
        .then((res) => {
          window.Toast.success("설정되었습니다");
          this.startTime = null;
          this.endTime = null;

          this.onClickCancel();
        })
        .catch((error) => {
          window.Toast.error(error.response.data.error.message);
        });
    },
    onClickCancel: async function () {
      await this.onCancel();
    },
    getArtistInfo(memberId) {
      this.memberIds = memberId;
    },
  },
};
</script>
<style lang="scss">
#collectionDetailModal .modal-dialog {
  max-width: 800px !important;
}

.member-select {
  margin-bottom: 30px;
}

.footer {
  .footer-buttons {
    width: 100px;
  }
}
</style>
